import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import goodJobSvg from '../../images/goodJob.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import Transition from './Transition';

const styles = {
	goodJobIcon: {
		display : 'inline-block',
		width : 50,
		height : 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title : {
		fontSize : 30,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	}
};

export default class GenericSavingDialog extends Component {
	render() {
		const {
			status, processingText, successText,
			open, onClose, onContinue,
		} = this.props;
		return (
			<div>
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={onClose}
				>
					<DialogTitle>
						<div>
							{status !== 'done' &&
								<div>
									<CircularProgress />
									<span style={styles.title}>Processing ...</span>
								</div>
							}
							{status === 'done' &&
								<div>
									<div style={styles.goodJobIcon}/>
									<span style={styles.title}>Success!</span>
								</div>
							}
						</div>
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{status !== 'done' && processingText}
							{status === 'done' && successText}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							disabled={status !== 'done'}
							onClick={onContinue}
							variant={"outlined"}
							color="primary"
						>
							Continue
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

GenericSavingDialog.propTypes = {
	status : PropTypes.string,
	open : PropTypes.bool,
	onClose : PropTypes.func,
	onContinue : PropTypes.func,
	processingText : PropTypes.string,
	successText : PropTypes.string,
};


GenericSavingDialog.defaultProps = {
	processingText : 'Currently processing...',
	successText : 'Everything saved successfully'
};
